import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { CategoryUploadSchema } from "./forms";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Dropzone } from "@common/components/Dropzone/Dropzone";

interface Props {
  form: UseFormReturn<z.infer<typeof CategoryUploadSchema>>;
  loading: boolean;
}

export const CategoryUploadForm = ({ form, loading }: Props) => {
  return (
    <Form {...form}>
      <div className="mb-5 text-slate">
        Upload a CSV file with all the categories in your organization.{" "}
        <a
          href="/hypercard_sample_categories_upload.csv"
          target="_blank"
          className="underline"
        >
          Click here
        </a>{" "}
        to download a template to fill out.
      </div>
      <form onSubmit={form.handleSubmit(() => {})} className="space-y-4">
        <FormField
          control={form.control}
          name="file"
          disabled={loading}
          render={({ field }) => (
            <FormItem className="w-full">
              <FormLabel className="mb-0">Category CSV File</FormLabel>
              <FormControl>
                <Dropzone
                  loading={loading}
                  onUpload={(value) => field.onChange(value)}
                  onError={() =>
                    form.setError("file", {
                      message: "File type is not valid",
                      type: "typeError",
                    })
                  }
                  onClearError={() => form.clearErrors("file")}
                  value={field.value}
                  field={field}
                  accept="text/csv"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};
